/*
*###############################################################################
*Module Name                   : BinMaster.js                                  #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Friday, September 16th 2021, 09:49:55 am      #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect, useContext } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Alert,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';

const moment = require('moment');
import DPPrintOption from 'framework/widgets/DPPrintOptions'
import BinContent from './BinContent'
import { getLocationMaster } from 'pages/Masters/Location-Master/LocationMasterController'
import { DownloadBincard, GetBincard, GetProductDescription, GetProductSearch, GetTxnDropdown } from './BinController'
import uuid from 'react-uuid'


const BinMaster = (props) => {

    let history = useHistory();

    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

    //*** User input related states */
    const [productCode, SetProductCode] = useState("");
    const [productDesc, setProductDesc] = useState("")
    const [locationCode, SetLocationCode] = useState("");
    const [allLocation, SetAllLocation] = useState(false);
    const [txnCode, SetTxnCode] = useState("");
    const [txnList, SetTxnList] = useState([])
    const [allTxn, SetAllTxn] = useState(false)
    const [menuCode, SetMenuCode] = useState("")
    const [fromDate, setFromDate] = useState(moment(firstDay).format("YYYY-MM-DD"))
    const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
    const [bincardData, setBincardData] = useState([])
    const [generateDisable, setGenerateDisable] = useState(false)
    const [triggerClear, setTriggerClear] = useState(false)



    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')

    const [modal_xlarge_product, setmodal_xlarge_product] = useState(false)
    const [modeal_xlarge_location, setmodeal_xlarge_location] = useState(false)

    const [saveEnable, setSaveEnable] = useState(false)
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [editEnable, SetEditEnable] = useState(false)
    const [Reason, setReason] = useState("Created")

    //*** End User activity related staes */

    //Alert Parameter
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")

    const [logLocationCode, setLogLocationCode] = useState("")
    const [locationName, setLocationName] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code

    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(true)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)

    const [printoptionShow, setprintoptionShow] = useState(false)
    const [helpUrl, setHelpUrl] = useState("")
    var time = process.env.REACT_APP_ALERTTIMEOUT
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    //const [ws, setWs] = useState(new WebSocket(`${socketURl}api/WebSocket/ws`));

    const [permissionGrantedAlertShow, setPermissionGrantedAlertShow] = useState(false)
    const [permissionGrantedAlertMsg, setPermissionGrantedAlertMsg] = useState("")
    const [permissionGrantedAlertColor, setPermissionGrantedAlertColor] = useState("")

    //import from contexts
    const {
        isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
    } = useContext(Context);
    //import from contexts


    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var LocationName = obj[4]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        setLogLocationCode(LocationCode)
        setLocationName(LocationName)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        if (!responseData.strMenuAccessRight) {
            history.push('/dashboard')
        }

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)
        setHelpUrl(responseData.strHelpUrl)
        var autoCodeRes = await fetchAutoCode(menu)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }

        var txnData = await GetTxnDropdown()
        SetTxnList(txnData)

    }, [])


    // AuditLog
    useEffect(async () => {

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log

    }, [])


    useEffect(() => {
        setGenerateDisable(false)
        setBincardData([])
    }, [txnCode, allLocation, locationCode, productCode, toDate, fromDate, allTxn])


    //*** Get and Set values when user search code */
    async function getProductData(searchData) {

        if (searchData == "") return

        if (locationCode == "") {
            displayAlertMessage('danger', "Please Enter Location Code !")
            SetProductCode("")
            setProductDesc("")
            return
        }

        const productData = await GetProductSearch(searchData, locationCode)

        if (!productData.success) {
            SetProductCode("")
            setProductDesc("")
            displayAlertMessage('danger', "Invalid Product Code !")
        }

    }

    async function getLocationData(searchData) {

        var locationData = await getLocationMaster(searchData)

        if (locationData.length == 0) {
            SetLocationCode("")
            displayAlertMessage('danger', "Invalid Location Code !")
        }

    }



    function tog_xlarge_product() {
        setmodal_xlarge_product(!modal_xlarge_product)
    }

    function tog_xlarge_location() {
        setmodeal_xlarge_location(!modeal_xlarge_location)
    }


    //save button function
    const handlesave = async (e) => {

    }


    const GetSelectedProduct = (e, row, isSelect, rowIndex) => {
        SetProductCode(row.IPLU_PRODUCTCODE);
        getProductDescription(row.IPLU_PRODUCTCODE)
        setmodal_xlarge_product(false);
    }

    const getProductDescription = async (proCode) => {

        if (proCode == "") {
            setProductDesc("")
            return
        }

        const { success, data } = await GetProductDescription(proCode)

        if (success) {
            setProductDesc(data)
        } else {
            SetProductCode("");
            setProductDesc("");
        }

    }



    const GetSelectedLocation = (e, row, isSelect, rowIndex) => {
        SetLocationCode(row.LOC_CODE);
        getLocationData(row.LOC_CODE)
        setmodeal_xlarge_location(!modeal_xlarge_location);
    }


    //edit button function    
    const handleEdit = e => {


        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)

    }

    //new button function
    const handleNew = e => {
        // e.preventDefault()
        ClearItem();
        setShow(false)
    }

    //clear fields function    
    const ClearItem = () => {
        SetProductCode("")
        setProductDesc("")
        SetLocationCode("")
        SetAllLocation(false)
        SetTxnCode("")
        SetAllTxn(false)
        setFromDate(moment(firstDay).format("YYYY-MM-DD"))
        setToDate(moment().format("YYYY-MM-DD"))
        setBincardData([])
        setGenerateDisable(false)

        setShow(false)

        SetAddNew(true)
        setErrorMsg('')
        SetDeleteEnable(false)
        setNullCode(false)

        setReason("Created")
        SetEditEnable(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setTriggerClear(prev => !prev)

    }

    //********Delete button function */
    const handleDelete = () => {
    }


    async function handlePrint(option) {
    }

    const PermissionHandle = (operation) => {

        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: logLocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {
                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()

                            } else if (Modify == true) {
                                handlesave()

                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")

                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")

                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()

                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")

                            }
                        } else if (operation == "PDF") {
                            if (Print == true) {
                                handlePrint("PDF")

                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")

                            }
                        } else if (operation == "XCEL") {
                            if (Print == true) {
                                handlePrint("XCEL")

                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    })

            } else if (Response.status == "400") {
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {

                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {

                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }


    async function RetreveData() {

        if (productCode == "") {
            displayAlertMessage('danger', "Please Enter Product Code !")
            return
        }

        if (locationCode == "") {
            displayAlertMessage('danger', "Please Enter Location Code !")
            return
        }

        if (txnCode == "" && allTxn == false) {
            displayAlertMessage('danger', "Please Select Transaction !")
            return
        }


        if (fromDate == "") {
            displayAlertMessage('danger', "Please Select From Date !")
            return
        }

        if (toDate == "") {
            displayAlertMessage('danger', "Please Select To Date !")
            return
        }

        var newUniqueID = uuid()

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Loading...")

        try{

            var bincardData = await GetBincard(productCode, txnCode, locationCode, newUniqueID)
      
            if (bincardData.success) {
                setGenerateDisable(true)
                var data = JSON.parse(bincardData.data);
                const sortedRows = data.sort(compareDates);
    
                const filterByDate = sortedRows.filter((item) => {
                    const date = new Date(item.BINCARD_DATE);
                    const fromDateLocal = new Date(fromDate);
                    const toDateLocal = new Date(toDate);
                    fromDateLocal.setHours(0, 0, 0, 0);
                    toDateLocal.setHours(0, 0, 0, 0);
                    date.setHours(0, 0, 0, 0);
                    return date >= fromDateLocal && date < toDateLocal.setDate(toDateLocal.getDate() + 1);
                });
    
    
                const filterByFromDate = sortedRows.filter((item) => {
                    const date = new Date(item.BINCARD_DATE);
                    const fromDateLocal = new Date(fromDate);
                    fromDateLocal.setHours(0, 0, 0, 0);
                    date.setHours(0, 0, 0, 0);
                    return date < fromDateLocal;
                });
    
                const inQty = filterByFromDate.reduce((acc, cur) => {
                    return acc + cur.BINCARD_QTYIN;
                }, 0);
    
                const outQty = filterByFromDate.reduce((acc, cur) => {
                    return acc + cur.BINCARD_QTYOUT;
                }, 0);
                
                // Create a new object for the OPB row
                const opbRow = {
                    BINCARD_DATE: fromDate,
                    BINCARD_QTYIN: inQty,
                    BINCARD_QTYOUT: outQty,
                    BINCARD_DESC: "OPB",
                    BINCARD_DOCNO: "",
                    BINCARD_TRNTYPE: "OPB",
                    BINCARD_SPRICE: "-",
                    BINCARD_APRICE: "-",
                    BINCARD_CPRICE: "-"
                };
    
                // Add the OPB row to the filtered data
                const bincardDataWithOPB = [opbRow, ...filterByDate];
    
                if (filterByFromDate.length > 0) {
                    setBincardData(bincardDataWithOPB);
                } else {
                    setBincardData(filterByDate);
                }
    
            } else {
                displayAlertMessage('danger', "No Data Found !")
            }
        }catch(error){
            console.log(error.message)
        }finally{
            SetLoadingAlert(false)
        }

    }


    async function ExportData() {

        if (productCode == "") {
            displayAlertMessage('danger', "Please Enter Product Code !")
            return
        }

        if (locationCode == "") {
            displayAlertMessage('danger', "Please Enter Location Code !")
            return
        }

        if (txnCode == "" && allTxn == false) {
            displayAlertMessage('danger', "Please Select Transaction !")
            return
        }


        if (fromDate == "") {
            displayAlertMessage('danger', "Please Select From Date !")
            return
        }

        if (toDate == "") {
            displayAlertMessage('danger', "Please Select To Date !")
            return
        }


        try{
            SetLoadingAlert(true)
            SetLoadingAlerttitle("Downloading...")

            const response = await DownloadBincard(productCode, txnCode, locationCode, fromDate, toDate, LogUserType, logLocationCode)

        }catch(error){
            console.log(error.message)
        }finally{
            SetLoadingAlert(false)
        }

    }








    const compareDates = (a, b) => {
        // const dateA = new Date(a.BINCARD_DATE);
        // const dateB = new Date(b.BINCARD_DATE);
        // return dateA - dateB;
        const dateA = a.BINCARD_DATE.substring(0, 10);
        const timeA = a.BINCARD_TIME.substring(11, 19);

        const dateB = b.BINCARD_DATE.substring(0, 10);
        const timeB = b.BINCARD_TIME.substring(11, 19);

        if (dateA !== dateB) {
            return dateA.localeCompare(dateB);
        } else {
            return timeA.localeCompare(timeB);
        }
    };

    // Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }


    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }


    return (
        < React.Fragment >
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <DPAlert
                        confirm_both={sweetAlertShow}
                        title={menuName}
                        description={AlertDescription}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        onConfirm={async () => {
                            setsweetAlertShow(false)
                            setPermissionName(LogUserType)
                            if (AlertConfirmOption == 1) {


                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                    handlesave()

                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {

                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else {
                                    if (addNew == false) {

                                    }
                                    setPermissionName("")
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }

                            } else if (AlertConfirmOption == 2) {
                                handleEdit()
                            } else if (AlertConfirmOption == 3) {
                                window.location.href = "/";
                            } else if (AlertConfirmOption == 4) {
                                handleNew()
                            } else if (AlertConfirmOption == 5) {

                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                    handleDelete()
                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                    setReason("")
                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else {
                                    setReason("")
                                    setPermissionName("")
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            } else if (AlertConfirmOption == 6) {

                                if (menuPrint == true && permissionReasonShow == false) {
                                    setprintoptionShow(true)
                                } else if (menuPrint == true && permissionReasonShow == true) {
                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else {
                                    setPermissionName("")
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            }

                        }}
                        onCancel={() => {
                            setsweetAlertShow(false)
                        }}
                    />
                    <DPPermission
                        confirm_both={permissionAlertShow}
                        title={menuName}
                        description={permissionAlertTitle}
                        showReason={permissionReasonShow}
                        nameDisable={false}//{permissionNameDisable}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        AlName={permissionName}
                        show={permissionGrantedAlertShow}
                        AlertColor={permissionGrantedAlertColor}
                        AlertMsg={permissionGrantedAlertMsg}
                        AlNameOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", false)
                            setPermissionName(val2)
                        }}
                        AlPassward={permissionPassword}
                        AlPasswardOnchange={e => {
                            let val2 = Text(e.target, 50, true, true, "any", false)
                            setPermissionPassword(val2)
                        }}
                        AlReason={Reason}
                        AlReasonOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setReason(val2)
                        }}
                        onConfirm={() => {

                            setPermissionAlertShow(false)
                            if (AlertConfirmOption == 1) {
                                PermissionHandle("Save")
                            } else if (AlertConfirmOption == 5) {
                                PermissionHandle("Delete")
                            } else if (AlertConfirmOption == 6) {
                                setprintoptionShow(true)
                            }
                        }}
                        onCancel={() => {
                            setPermissionAlertShow(false)
                        }}
                    />
                    <DPPrintOption
                        confirm_both={printoptionShow}
                        title={menuName}
                        showCancel={true}
                        cancelColor={"danger"}
                        onConfirmpdf={() => {
                            handlePrint("PDF")
                            setprintoptionShow(false)
                        }}
                        onConfirmxcel={() => {
                            handlePrint("XCEL")
                            setprintoptionShow(false)
                        }}
                        onCancel={() => {
                            setprintoptionShow(false)
                        }}
                    />
                    <DPLoadingAlert
                        confirm_both={loadingAlert}
                        title={loadingAlertTitle}
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable && isHeadOffice}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button

                                        printEnable={false}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        {show ? (
                                            <Alert color={AlertColor} role="alert">
                                                {AlertMsg}
                                                <br />
                                                <small>{ErrorMsg}</small>
                                            </Alert>
                                        ) : null}
                                    </Row>
                                    <Row>
                                        <BinContent
                                            modal_xlarge_product={modal_xlarge_product}
                                            tog_xlarge_product={tog_xlarge_product}
                                            modeal_xlarge_location={modeal_xlarge_location}
                                            tog_xlarge_location={tog_xlarge_location}

                                            GetSelectedProduct={GetSelectedProduct}
                                            GetSelectedLocation={GetSelectedLocation}


                                            productCode={productCode}
                                            productDesc={productDesc}
                                            SetProductCode={SetProductCode}
                                            getProductDescription={getProductDescription}
                                            locationCode={locationCode}
                                            SetLocationCode={SetLocationCode}
                                            allLocation={allLocation}
                                            SetAllLocation={SetAllLocation}
                                            SetTxnCode={SetTxnCode}
                                            txnCode={txnCode}
                                            SetAllTxn={SetAllTxn}
                                            allTxn={allTxn}
                                            fromDate={fromDate}
                                            toDate={toDate}
                                            setFromDate={setFromDate}
                                            setToDate={setToDate}
                                            bincardData={bincardData}
                                            generateDisable={generateDisable}


                                            menuCode={menuCode}
                                            txnList={txnList}

                                            locationOnBlur={(e) => {
                                                if (e.target.value == "") return
                                                getLocationData(e.target.value)
                                            }}
                                            productOnBlur={(e) => {
                                                if (e.target.value == "") return
                                                getProductData(e.target.value)
                                            }}
                                            RetreveData={RetreveData}
                                            ExportData={ExportData}
                                            displayAlertMessage={displayAlertMessage}
                                            triggerClear={triggerClear}

                                        />
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment >
    )

}

export default BinMaster

